import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage1280 from "../../Assets/Images/ab-3-Female-1280-1919.png";
import SectionTwoImage1920 from "../../Assets/Images/ab-3-Female-1920.png";
import SectionTwoImageMobile from "../../Assets/Images/Values-2-Mob.png";
import wardsImage from "../../Assets/Images/wards-logo.png";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const Ward = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div className="flex-1">
        {/* Desktop 1280-1919 */}
        <div className="hidden lg:block [@media(min-width:1920px)]:hidden">
          <CapsuleImageVertical image={SectionTwoImage1280} />
        </div>
        {/* Desktop 1920+ */}
        <div className="hidden [@media(min-width:1920px)]:block">
          <CapsuleImageVertical image={SectionTwoImage1920} />
        </div>
        <div className="mt-8 mb-4 -mr-4 md:mr-0 md:pl-4 lg:hidden flex md:max-w-[664px] overflow-hidden md:overflow-visible reveal-up">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-[130%] md:w-full max-w-none md:max-w-full"
          />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-32 reveal-up  lg:pl-0 px-4">
        <h3 className="md:text-[24px] font-semibold mb-4 text-[16px] leading-[20px]  md:leading-[28px] extra-title36">
          {translations.valuesWardsTitle}
        </h3>
        <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-4 text-justify extra-para-vs">
          {translations.valuesWardsDescription1}
        </p>
        <p
          className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-4 text-justify extra-para-vs"
          dangerouslySetInnerHTML={{
            __html: translations.valuesWardsDescription2,
          }}
        ></p>
        {
          <img
            src={wardsImage}
            className="max-w-[80px] max-h-[80px] [@media(min-width:1920px)]:max-w-[150px] [@media(min-width:1920px)]:max-h-[150px] hidden lg:block"
            alt="awards-logo"
          />
        }
      </div>
    </>
  );
};

export default Ward;
